// File: src/components/Blog/BlogHeroSection.jsx

import React from 'react';

export default function BlogHeroSection() {
  return (
    <div className="bg-gradient-to-r from-black via-purple-900 to-black py-20 text-center text-white px-4">
      <h1 className="text-4xl md:text-6xl font-bold mb-4">
        Our Latest Blog Posts
      </h1>
      <p className="text-lg md:text-xl max-w-3xl mx-auto">
        Stay tuned with us for exciting financial market posts.
      </p>
    </div>
  );
}
